export default __webpack_public_path__ + "appointments/static/media/naturalblde-lightbrwn.1c034ebb.png";